"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabState = void 0;

/**
 * Active and inactive classNames of the SbTab.
 * @type {{ACTIVE: string, INACTIVE: string}}
 */
var tabState = {
  ACTIVE_TAB: 'active',
  INACTIVE_TAB: 'inactive'
};
exports.tabState = tabState;
//# sourceMappingURL=constants.js.map